module.exports = "<div class=\"sun-report-modal sun-report-mordal--fail\">\r\n  <p class=\"sun-icon-fail\"></p>\r\n  <p class=\"sun-report-modal-text\">{{title}}</p>\r\n  <p class=\"sun-report-modal-text-sub\">{{message}}</p>\r\n  <p class=\"sun-report-modal-text-sub\">{{detail}}</p>\r\n  <p class=\"sun-report-modal-close\">\r\n    <a (click)=\"close()\">\r\n      <i class=\"sun-icon-dismiss\"></i>閉じる</a>\r\n  </p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/error-handler/error-dialog.component.html
// module id = ./src/app/error-handler/error-dialog.component.html
// module chunks = main